import React, {Fragment} from 'react';
import block from 'bem-cn-lite';
import closeIcon from '@yandex-data-ui/common/assets/icons/preview-close.svg';

import ButtonWithIcon from 'components/Buttons/ButtonWithIcon/ButtonWithIcon';
import ToggleArrow from 'components/ToggleArrow/ToggleArrow';
import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';

import './Banner.scss';

export interface BannerEventData {
    id: string | number;
    url: string;
    text: string | null;
}

export interface BannerEventProps extends WithTranslationProps {
    event: BannerEventData;
    onClose: () => void;
    theme?: 'default' | 'custom';
    className?: string;
}

const b = block('banner');

const Banner: React.FC<BannerEventProps> = ({
    className,
    event,
    onClose,
    i18nK,
    theme = 'default',
}) => {
    return (
        <div className={b({theme}, className)}>
            <div className={b('info')}>
                <div className={b('title')}>
                    {theme !== 'custom' && (
                        <Fragment>
                            {i18nK('banner-event-prefix')}
                            &nbsp;
                        </Fragment>
                    )}
                    {event.text}
                </div>
                <a href={event.url} className={b('link')} onClick={onClose}>
                    {i18nK('banner-event-action')}
                    <ToggleArrow
                        size={12}
                        type={'horizontal'}
                        iconType="navigation"
                        className={b('icon')}
                    />
                </a>
            </div>
            <ButtonWithIcon
                className={b('close-button')}
                onClick={onClose}
                icon={closeIcon}
                iconSize={24}
                theme="accent"
            />
        </div>
    );
};

export default withTranslation('common')(Banner);
